// How often a Circle meets, as `circles.meeting_cadence` stores it. One list
// for the Circle request/response schemas and the web forms; the
// `circles_meeting_cadence_check` constraint mirrors it, so changing a
// cadence is a migration.
import { z } from 'zod';
export const CIRCLE_MEETING_CADENCES = ['weekly', 'every_two_weeks', 'monthly'];
export const CircleMeetingCadenceSchema = z.enum(CIRCLE_MEETING_CADENCES);
//# sourceMappingURL=circle-meeting-cadence.js.map